import moment, { isMoment } from 'lib/utils/date';

export const isRange = (value) => 'from' in value || 'to' in value;

export const sortRange = (range) => {
  let fromDate = (range.from || range.to) || null;
  let toDate = (range.from && range.to) || null;
  //console.log('sort.range', range);
  if (fromDate && toDate) {
    return {
      from: moment.min([fromDate, toDate]),
      to: moment.max([fromDate, toDate]),
    };
  }
  return {
    from: fromDate,
    to: toDate,
  };
};

// eslint-disable-next-line complexity
export const transformDateValue = (value, toRange) => {
  if (toRange) {
    if (!value) {
      return { from: null, to: null };
    }

    if (isMoment(value)) {
      return { from: value, to: value };
    }

    if (isRange(value)) {
      const range = [
        transformDateValue(value.from, false),
        transformDateValue(value.to, false),
      ].sort((a, b) => a && b ? a.diff(b) : 0);

      return {
        from: range[0],
        to: range[1],
      };
    }
  } else {
    if (!value) {
      return null;
    }

    if (isMoment(value)) {
      return moment(value);
    }

    if (value instanceof Date) {
      return moment(value);
    }

    if (isRange(value)) {
      if (('from' in value) && !!value.from) {
        return transformDateValue(value.from, false);
      }

      if (('to' in value) && !!value.to) {
        return transformDateValue(value.to, false);
      }
    }
  }
};

export const toggleRange = (dateRange, momentDate) => {
  if (dateRange.from && dateRange.to) {
    dateRange = {
      to: null,
      from: momentDate,
    };
  } else if (dateRange.from) {
    dateRange.to = momentDate;
    return dateRange;
  } else {
    dateRange.from = momentDate;
  }
  return dateRange;
};

export const boundsNumber = (value, bounds) => {
  if (value === null || value === undefined) {
    return value;
  }
  if (bounds.length !== 2) {
    return value;
  }

  const min = Math.min(...bounds);
  const max = Math.max(...bounds);
  if (value < min) {
    return min;
  }

  if (value > max) {
    return max;
  }
  return value;
};

export const isEqualMoment = (m1, m2) => m1 === m2 || (isMoment(m1) && isMoment(m2) && !m1.diff(m2, 'days'));

export const isEqualDate = (v1, v2) => isEqualMoment(v1, v2)
    || (isEqualMoment(v1.from, v2.from) && isEqualMoment(v1.to, v2.to))
    || (isEqualMoment(v1.from, v2.to) && isEqualMoment(v1.to, v2.from));

export const boundDate = (date, bounds) => {
  if (date === null || date === undefined) {
    return date;
  }

  if (bounds.length !== 2) {
    return date;
  }

  const min = moment.min(bounds);
  const max = moment.max(bounds);

  if (date.diff(min, 'days') < 0) {
    return min;
  }

  if (date.diff(max, 'days') > 0) {
    return max;
  }

  return date;
};
